import { type HttpClient } from '../useHttpClient';

type UserGroupMembership = {
  userId: number;
  groupId: number;
};

type RequestSchema = {
  data: UserGroupMembership[];
};

export const removeUserGroupMembers =
  (httpClient: HttpClient) => async (request: RequestSchema) => {
    await httpClient.api('/admin/user-group-members', {
      method: 'DELETE',
      body: JSON.stringify(request),
    });
  };

export const addUserGroupMembers =
  (httpClient: HttpClient) => async (request: RequestSchema) => {
    await httpClient.api('/admin/user-group-members', {
      method: 'POST',
      body: JSON.stringify(request),
    });
  };
